export default {
  // title: 'Web project',
  logo: {
    part1: 'ROVI',
    part2: 'SPORT',
    extraInfo: 'Váš špecialista na bicykle',
  },
  nav: {
    aboutUs: 'O nás',
    map: 'Mapa',
    contact: 'Kontakt',
    openCloseTextVisible: true, // Vypnutie textu otvorené/zatvorené na hlavnej stránke
    mobileVisible: true, // Zobrazenie textu mobilny telefon na hlavnej stránke
    emailVisible: true, // Zobrazenie textu email na hlavnej stránke
    openText: 'Dnes otvorené do ${time}',
    openTomorrowText: 'Otvorené zajtra od ${time}',
    openFromExtendedText: 'Otvorené od ${day} ${time}',
  },
  foot: {
    title: '',
  },
  home: {
    title: '',
    description: '',
    descriptionActionButton: 'Ponuka bicyklov',
    descriptionActionLink: 'https://www.ctm.sk/bicykle',
  },
  services: {
    title: 'Výhody',
    subTitle: '',
    description:
      'Odo dňa kúpy bicykla Vám na ňom do 30 dní spravíme bezplatnú servisnú prehliadku\n' +
      '\n' +
      'Prevádzame garančné prehliadky, záručný a pozáručný servis\n' +
      '\n' +
      'Atypický tovar na objednávku\n' +
      '\n' +
      'Možnosť platby kartou\n' +
      '\n' +
      'Predaj na splátky',
  },
  aboutUs: {
    title: 'O nás',
    subTitle: '',
    description:
      'Radi by sme Vám predstavili a ponúkli bicykle značky CTM.\n' +
      'Navštívte nás v našej predajni Martin - Priekopa, kde Vám ponúkneme široký sortiment cenovo dostupných a kvalitných bicyklov.\n' +
      '\n' +
      'Sme si istí, že si z našej ponuky vyberiete bicykel, ktorý splní Vaše očakávania a predstavy.\n' +
      '\n' +
      '\n' +
      'Tím Rovisport',
  },
  contact: {
    title: 'Kontakt',
    addressTitle: 'Adresa',
    address: 'J.Martáka 1, Priekopa\n036 08 Martin 8',
    openingHoursTitle: 'Otváracie hodiny',
    phoneTitle: 'Tel:',
    emailTitle: 'Email:',

    lunchVisible: true, // Zobrazenie textu obed v kontakt sekcii
    lunch: 'Obed',
    openingHoursDays: {
      1: 'PO',
      2: 'UT',
      3: 'ST',
      4: 'ŠT',
      5: 'PI',
      6: 'SO',
      7: 'NE',
    },
  },
  client: {
    name: 'RoVi Sport',
    googleCompanyName: 'RoVi Sport',
    fullName: 'Rovisport, s.r.o.',
    email: 'rovisport@rovisport.sk',
    phone: '+421 915 049 444',
    address: 'J.Martáka 1, Priekopa, 036 08 Martin 8',
    coordinates: {
      lat: 49.103420546511884,
      lng: 18.923387528991853,
    },
  },
  openingHours: {
    // Potreba zanechať formát s pomlčkami pre "openCloseTextVisible"
    1: '09:00 - 17:00', // Pondelok
    2: '09:00 - 17:00', // Utorok
    3: '09:00 - 17:00', // Streda
    4: '09:00 - 17:00', // Štvrtok
    5: '09:00 - 17:00', // Piatok
    6: '09:00 - 12:00', // Sobota
    7: 'Zatvorené', // Nedeľa
  },
  openingHoursLunch: '12:00 - 13:00', // Obed
};
